package de.oevbs.kunde.kundenportal2.model.services.contract

import de.oevbs.businesspartner.bpcrmservice2.common.model.LineOfBusiness
import dev.fritz2.core.Lenses

@Lenses
data class ContractFilter(val lineOfBusiness: LineOfBusiness, val showArchived: Boolean) {
    companion object {
        val emptyFilter = ContractFilter(LineOfBusiness.Unbekannt, false)
    }
}